// extracted by mini-css-extract-plugin
export var button = "_co-0";
export var donut = "_co-1";
export var donutFill = "_co-3";
export var donutTrack = "_co-2";